const actions = {
    // ── Insumos / Mercancía ───────────────────────────────────────────────────
    GET_INSUMOS_REQUEST:  'GET_INSUMOS_REQUEST',
    GET_INSUMOS_SUCCESS:  'GET_INSUMOS_SUCCESS',
    CREATE_INSUMO_REQUEST:'CREATE_INSUMO_REQUEST',
    CREATE_INSUMO_SUCCESS:'CREATE_INSUMO_SUCCESS',
    EDIT_INSUMO_REQUEST:  'EDIT_INSUMO_REQUEST',
    EDIT_INSUMO_SUCCESS:  'EDIT_INSUMO_SUCCESS',
    DELETE_INSUMO_REQUEST:'DELETE_INSUMO_REQUEST',
    DELETE_INSUMO_SUCCESS:'DELETE_INSUMO_SUCCESS',
    GET_MERCANCIAS_REQUEST:'GET_MERCANCIAS_REQUEST',
    GET_MERCANCIAS_SUCCESS:'GET_MERCANCIAS_SUCCESS',

    SET_CURRENT_INSUMO:   'SET_CURRENT_INSUMO',
    CLEAR_CURRENT_INSUMO: 'CLEAR_CURRENT_INSUMO',
    SET_CURRENT_PROCESO:  'SET_CURRENT_PROCESO',
    CLEAR_CURRENT_PROCESO:'CLEAR_CURRENT_PROCESO',

    // ── Registro legado ───────────────────────────────────────────────────────
    GET_INVENTARIO:          'GET_INVENTARIO',
    SET_REGISTRO_INVENTARIO: 'SET_REGISTRO_INVENTARIO',
    GET_REGISTRO_INVENTARIO: 'GET_REGISTRO_INVENTARIO',
    GET_REGISTRO_SUCCESS:    'GET_REGISTRO_SUCCESS',

    // ── Movimientos (nuevo sistema) ───────────────────────────────────────────
    GET_MOVIMIENTOS_REQUEST: 'INVENTARIO_GET_MOVIMIENTOS_REQUEST',
    GET_MOVIMIENTOS_SUCCESS: 'INVENTARIO_GET_MOVIMIENTOS_SUCCESS',

    // ── Stock actual ──────────────────────────────────────────────────────────
    GET_STOCK_REQUEST: 'GET_STOCK_REQUEST',
    GET_STOCK_SUCCESS: 'GET_STOCK_SUCCESS',

    // ── Alertas stock mínimo ──────────────────────────────────────────────────
    GET_ALERTAS_REQUEST: 'GET_ALERTAS_REQUEST',
    GET_ALERTAS_SUCCESS: 'GET_ALERTAS_SUCCESS',

    // ── Ajuste manual ─────────────────────────────────────────────────────────
    CREAR_AJUSTE_REQUEST: 'CREAR_AJUSTE_REQUEST',
    CREAR_AJUSTE_SUCCESS: 'CREAR_AJUSTE_SUCCESS',

    // ── Reporte de rotación ───────────────────────────────────────────────────
    GET_ROTACION_REQUEST: 'GET_ROTACION_REQUEST',
    GET_ROTACION_SUCCESS: 'GET_ROTACION_SUCCESS',

    // ── Action creators ───────────────────────────────────────────────────────
    initDataIsumos:    (query) => ({ type: actions.GET_INSUMOS_REQUEST, query }),
    initDataMercancias: ()     => ({ type: actions.GET_MERCANCIAS_REQUEST }),

    createInsumo: data => ({ type: actions.CREATE_INSUMO_REQUEST, payload: data }),
    editInsumo:   data => ({ type: actions.EDIT_INSUMO_REQUEST,   payload: data }),
    deleteInsumo: id   => ({ type: actions.DELETE_INSUMO_REQUEST,  payload: id }),

    setCurrentInsumo:   data => ({ type: actions.SET_CURRENT_INSUMO,   payload: data }),
    clearCurrentInsumo: ()   => ({ type: actions.CLEAR_CURRENT_INSUMO }),
    setCurrentProceso:  data => ({ type: actions.SET_CURRENT_INSUMO,   payload: data }),
    clearCurrentProceso:()   => ({ type: actions.CLEAR_CURRENT_INSUMO }),

    getInventario:       ()   => ({ type: actions.GET_INVENTARIO }),
    registroInventario:  data => ({ type: actions.SET_REGISTRO_INVENTARIO, payload: data }),
    getRegistroInventario:(query) => ({ type: actions.GET_REGISTRO_INVENTARIO, query }),

    // Movimientos
    getMovimientos: (query) => ({ type: actions.GET_MOVIMIENTOS_REQUEST, query }),

    // Stock
    getStock:    (query) => ({ type: actions.GET_STOCK_REQUEST, query }),

    // Alertas
    getAlertas:  ()      => ({ type: actions.GET_ALERTAS_REQUEST }),

    // Ajuste
    crearAjuste: data    => ({ type: actions.CREAR_AJUSTE_REQUEST, payload: data }),

    // Rotación
    getRotacion: (query) => ({ type: actions.GET_ROTACION_REQUEST, query }),
};

export default actions;
